<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><g clip-path="url(#clip0_748_46448)" stroke="transparent"><g clip-path="url(#clip1_748_46448)"><path d="M3.125 0h10l5 5v13.75c0 .69-.56 1.25-1.25 1.25H3.125c-.69 0-1.25-.56-1.25-1.25V1.25c0-.69.56-1.25 1.25-1.25Z" fill="#749EFF"></path><g clip-path="url(#clip2_748_46448)"><path d="M9.375 10.306a.689.689 0 0 0 0-.972.69.69 0 0 0-.973 0L6.214 11.52a1.721 1.721 0 0 0 0 2.43c.67.67 1.755.672 2.431 0l4.132-4.131a1.72 1.72 0 0 0-2.43-2.431l-.122.122a.516.516 0 0 1-.729-.73l.121-.121a2.753 2.753 0 0 1 3.89 0 2.753 2.753 0 0 1 0 3.889L9.373 14.68a2.751 2.751 0 0 1-3.882-.007 2.75 2.75 0 0 1-.006-3.882l2.187-2.187a1.72 1.72 0 0 1 2.43 0c.67.67.672 1.756 0 2.43l-2.065 2.066a.516.516 0 0 1-.73-.729l2.067-2.066Z" fill="#fff"></path></g><path d="m13.125 0 5 5h-3.75c-.69 0-1.25-.56-1.25-1.25V0Z" fill="#B9CEFF"></path></g></g><defs><clipPath id="clip0_748_46448"><path fill="#fff" d="M0 0h20v20H0z"></path></clipPath><clipPath id="clip1_748_46448"><path fill="#fff" d="M0 0h20v20H0z"></path></clipPath><clipPath id="clip2_748_46448"><path fill="#fff" transform="translate(4 5)" d="M0 0h11v11H0z"></path></clipPath></defs></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconFileColor',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-file-color`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
